import React from "react";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { subTypes, types } from "./itemTypes";

function Text(props) {
  const { t } = useTranslation();
  switch (props.question.type) {
    case types.container:
      return t("editor.questionTypes.container.footer", {
        number: props.childrenLength,
      });
    case types.open:
      return t("editor.questionTypes.open.footer");

    case subTypes.text:
      return t("editor.questionTypes.text.footer");
      
    default:
      return `${props.question.type} ${t("editor.placeholders.item")}`;
  }
}

export default function Open(props) {
  return (
    <React.Fragment>
      <Typography
        variant="body2"
        sx={{
          cursor: "default",
          color: "text.secondary",
          width: "30%",
          padding: 1,
          textAlign: "left",
        }}
      >
        <Text {...props} />
      </Typography>
    </React.Fragment>
  );
}
